import _ from "lodash";
import React, { useEffect, useState } from "react";
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { Firestore } from "../firebase/firebase";
import { getAdvertisers } from "../firebase";
import {
  fetchTemplate,
  fetchTemplates,
  fetchAdvertisers,
  fetchBanner,
} from "../actions";
import Loading from "../app/loading";
import Default from "../templates/default/stage";
import CompManager from "./component-manager";

const Template = () => {
  let { template, retailer } = useParams();
  let location = useLocation();

  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const templates = useSelector((state) => state.templates);
  const tmpl = useSelector((state) => state.template);

  const [templateName, setTemplateName] = useState();
  const [showLoading, setShowLoading] = useState(true);

  const [value] = useDocument(doc(Firestore, "retailers", retailer), {
    snapshotListenOptions: { includeMetadataChanges: true },
  });

  useEffect(() => {
    if (value) {
      if (value.exists) {
        dispatch(fetchTemplates(value.data()));
      }
    }
    return () => {
      dispatch(fetchTemplates({}));
      dispatch(fetchBanner({}));
    };
  }, [value, dispatch]);

  // get advertisers for current retailer
  useEffect(() => {
    if (user) getAdvertisers(retailer, user, dispatch);
    return () => dispatch(fetchAdvertisers([]));
  }, [retailer, user, dispatch]);

  useEffect(() => {
    const { pathname } = location;
    if (!_.isEmpty(templates)) {
      const findTemplate = async (template) => {
        return _.find(templates.templates, (item) => {
          return item.name === template;
        });
      };
      findTemplate(template).then((t) => {
        dispatch(fetchTemplate(t));
      });
    }
    return () => {
      if (pathname.indexOf("new/trade") === -1) dispatch(fetchTemplate({}));
    };
  }, [template, dispatch, templates, location]);

  useEffect(() => {
    if (tmpl && tmpl.displayName) {
      if (templateName !== tmpl.name) {
        setTemplateName(tmpl.name);
        setShowLoading(false);
      }
    }
  }, [tmpl, templateName]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  if (showLoading) return <Loading />;

  return (
    <div className={`bm-template ${tmpl.name}-template`}>
      {tmpl.type === "bespoke" && (
        <CompManager
          compName={`Stage${templateName}`}
          location={location}
          retailer={retailer}
          template={tmpl}
        />
      )}
      {tmpl.type === "native" && (
        <Default
          location={location}
          retailer={retailer}
          template={templateName}
        />
      )}
      {tmpl.type === "custom" && (
        <Default
          location={location}
          retailer={retailer}
          template={templateName}
        />
      )}
      {tmpl.type === "standard" && (
        <CompManager
          compName={`${capitalizeFirstLetter(tmpl.service)}Standard`}
          retailer={retailer}
          template={templateName}
          location={location}
        />
      )}
      {tmpl.type === "hybrid" && (
        <CompManager
          compName={`Stage${templateName}`}
          location={location}
          retailer={retailer}
          template={tmpl}
        />
      )}
      {tmpl.type === "bespoke" && (
        <Routes>
          <Route
            path="/:retailer/new/:template"
            element={
              user ? (
                <CompManager
                  compName={`Form${template}`}
                  retailer={retailer}
                  template={tmpl}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
        </Routes>
      )}
    </div>
  );
};

export default Template;
